"use client";

import { userSchema } from "../../../../lib/types/schema/user/userSchema";
import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCommunityMember } from "./keyCommunityMember";

export type UseRequestCommunityMemberProps = UseRequestQueryProps & {
  communityId: number;
  userId: number;
};

export const useRequestCommunityMember = ({
  communityId,
  userId,
  ...props
}: UseRequestCommunityMemberProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: () => ({
      schema: userSchema,
      urlBackendPath: `/communities/${communityId}/members/${userId}`,
    }),
    queryKey: keyCommunityMember({ communityId, userId }),
  }),
});
